import { Box, DialogContent, DialogTitle, Paper, Typography } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useContext } from 'react'

import { Actions, QuadkeyMap } from '../../Components'
import { EthersContext, useAuction } from '../../Contexts'

interface Props {
  quadkey: Quadkey
}

const CompletedView: React.FC<Props> = (props) => {
  const { quadkey } = props
  const { localAddress } = useContext(EthersContext)
  const { auction } = useAuction(quadkey)

  if (auction) {
    const { bidder, canMintForReward } = auction.dynamic
    const size = '80vmin'

    return (
      <Box alignItems="center" display="flex" flexDirection="column" justifyContent="center">
        <Box height={size} justifyContent="center" margin="2px" width={size}>
          {quadkey ? <QuadkeyMap crop={true} imgSize={size} quadkey={quadkey} size={512} /> : null}
        </Box>
        <Box sx={{ display: { md: 'flex', xs: 'none' } }} position="absolute">
          <Paper style={{ opacity: 0.8 }}>
            <Box>
              <DialogTitle>Completed</DialogTitle>
              <DialogContent>
                <Box display="flex" justifyContent="cener" maxWidth={300} padding={1}>
                  <Typography variant="body2">This auction has been completed, but still needs to be minted.</Typography>
                </Box>
                <Box display="flex" justifyContent="cener" maxWidth={300} padding={1}>
                  <Actions quadkey={quadkey} />
                </Box>
                <Box display="flex" justifyContent="cener" maxWidth={300} padding={1}>
                  {localAddress !== bidder && !canMintForReward ? (
                    <Typography variant="body2">
                      Note: The high bidder has 24 hours after the auction completes to mint the auction, otherwise, Mint w/Reward becomes available
                    </Typography>
                  ) : null}
                </Box>
              </DialogContent>
            </Box>
          </Paper>
        </Box>
        <Box sx={{ display: { md: 'none' } }}>
          <DialogTitle>Completed</DialogTitle>
          <DialogContent>
            <Box display="flex" justifyContent="cener" maxWidth={300} padding={1}>
              <Typography variant="body2">This auction has been completed, but still needs to be minted.</Typography>
            </Box>
            <Box display="flex" justifyContent="cener" maxWidth={300} padding={1}>
              <Actions quadkey={quadkey} />
            </Box>
            <Box display="flex" justifyContent="cener" maxWidth={300} padding={1}>
              {localAddress !== bidder && !canMintForReward ? (
                <Typography variant="body2">
                  Note: The high bidder has 24 hours after the auction completes to mint the auction, otherwise, Mint w/Reward becomes available
                </Typography>
              ) : null}
            </Box>
          </DialogContent>
        </Box>
      </Box>
    )
  }
  return null
}

export default CompletedView
